import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import config from 'config/default.json';
import { TableComponent } from 'src/app/back-office/components/table/table.component';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { VcaDetailDepModComponent } from './vca-detail-dep-mod/vca-detail-dep-mod.component';

@Component({
  selector: 'app-vca-department-module',
  templateUrl: './vca-department-module.component.html',
  styleUrls: ['./vca-department-module.component.scss', '../../../components/table/table.component.scss']
})
export class VcaDepartmentModuleComponent extends TableComponent{
constructor(
      private elRef:ElementRef,
      public cdRef: ChangeDetectorRef,
      public helper: HelperModule,
      public dialog: MatDialog,
      private apiService: ApiServiceModule,
      private sharedService: SharedService,
      public sanitizer: DomSanitizer) {
        super(sanitizer);
    }
  @Output() inProgress = new EventEmitter<any>();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() filterData:any;
  @Input() platformInfos: { [x:string]: any } = new Map();
  @Input() manageKey:string = 'vca_structure';
  metaData:{[x: string]: any} = new Map();
  elementData:{[x: string]: any}[]= [];
  manageKeyValue:any = {
    'vca_institution': {element: 'Institution', parent: 'Country'},
    'vca_structure': {element: 'Structure', parent: 'Institution'},
    'vca_department': {element: 'Depatment', parent: 'Structure'},
    'vca_module': {element: 'Module', parent: 'Department'},
    'vca_content': {element: 'Content', parent: 'Module'},
  };
  mergeData:{[x: string]: any}[]= [];

  ngOnInit() {
    this.loadData();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterData'] && !changes['filterData'].firstChange) {
      this.loadData();
    }
  }
  loadData(){
    this.inProgress.emit(true);
    if(this.filterData && Object.keys(this.filterData).length > 0){
      this.filterData.offset = this.navIndex * this.filterData.limit;
      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/web/vca-department-module/load_vca', this.filterData, this.userInfos['access_token']).subscribe((response:any)=>{
        this.dataSource = response?.data ?? [];
        this.metaData = response?.metadata ?? [];
        this.showedRows = this.dataSource;
        this.mergeData = this.dataSource;
        this.totalRows = this.dataSource?.[0]?.total_rows ?? 0;
        this.totalNavigations = Math.ceil(this.totalRows / this.filterData.limit);

        this.inProgress.emit(false);
      });
    }
  }
  
  
  setUpdatedRow(data:any){

  }
  toggleRow(row:any, clickedElm:any, rowTab:any){
    let toExpand = true;
    for (var tdTab of rowTab.querySelectorAll('.to_skip_element')){
      if(tdTab.contains(clickedElm)){
        toExpand = false;
        break;
      }
    }
    if(toExpand){
      row['expanded'] =! row['expanded'];
    }
  }
  setWaiting(data:any){

  }
  depInsModAdd(){
    
  }
  depInsModOption(rowInfos:{ [x:string]: any },){
    /* let duplicateRows = this.classifyData.filter((row: any)=> row.id_content_duplicate == rowInfos['id_content'] && row.source == 'content')
    const dialogRef = this.dialog.open(ClassifySettingComponent, {
      width: '70%',
      position: {top: '30px' },
      data: {is_multiple: false, selected_rows: [rowInfos], duplicate_rows: duplicateRows, user_infos: this.userInfos, platform_infos: this.platformInfos, project_infos: this.projectInfos}
    });
    dialogRef.afterClosed().subscribe((response:any) => {
      
    }); */
  }
  depInsModSetting(){
    let selectedRows = this.selectRows();
    if(selectedRows.length){
      const dialogRef = this.dialog.open(VcaDetailDepModComponent, {
        width: '70%',
        position: {top: '30px' },
        data: {action: 'import_object', filter_data: this.filterData, manage_key: this.manageKey, manage_key_value: this.manageKeyValue, user_infos: this.userInfos, selected_rows: selectedRows, platform_infos: this.platformInfos}
      });
      dialogRef.afterClosed().subscribe((response:any) => {
        
      });
    }else{
      const dialogRef = this.dialog.open(VcaDetailDepModComponent, {
        width: '90%',
        position: {top: '30px' },
        data: {action: 'add_new', filter_data: this.filterData, manage_key: this.manageKey, manage_key_value: this.manageKeyValue, row_infos: {}, metadata: this.metaData, merge_data: {}, user_infos: this.userInfos, platform_infos: this.platformInfos}
      });
      dialogRef.afterClosed().subscribe((response:any) => {
      
      });
    }
  }
  movePrevNextNavigation(action:string) {
    if (action == 'prev' && this.navIndex > 0) {
      this.navIndex--;
      this.loadData();
    }
    if (action == 'next' && this.navIndex < this.totalNavigations - 1) {
      this.navIndex++;
      this.loadData();
    }
  }
  selectAllOption(element: any){
    this.selectAll(element);
    this.cdRef.detectChanges();
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }
}
